import { render, staticRenderFns } from "./LabelTemplateSelect.vue?vue&type=template&id=4eff7d6b&scoped=true"
import script from "./LabelTemplateSelect.vue?vue&type=script&lang=js"
export * from "./LabelTemplateSelect.vue?vue&type=script&lang=js"
import style0 from "./LabelTemplateSelect.vue?vue&type=style&index=0&id=4eff7d6b&prod&scoped=true&lang=css"
import style1 from "./LabelTemplateSelect.vue?vue&type=style&index=1&id=4eff7d6b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eff7d6b",
  null
  
)

export default component.exports